import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

interface IconProps extends React.HTMLAttributes<HTMLImageElement> {
    name: string; // 不带 .svg 后缀
    size?: number;
}

export function Icon({ name, size = 24, ...props }: IconProps) {
    return (
        <img
            src={getStaticAssetUrl(`/icons/${name}.svg`)}
            alt={name}
            width={size}
            height={size}
            {...props}
        />
    );
}

export default Icon;
